import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['btnPickSchedule'];

  connect() {
    $('#edit-attendance-turbo-modal .select2').select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: false,
      width: 'resolve',
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal')
    });

    if (this.hasBtnPickScheduleTarget) {
      this.openPickSchedule();
      this.btnPickScheduleTarget.addEventListener('click', (ev) => this.openPickSchedule());
    }
  }

  openPickSchedule() {
    this.$modalSchedule = document.querySelector('.schedule-board-modal');
    let turboFrame = document.querySelector(this.element.dataset.pickScheduleTarget);

    turboFrame.setAttribute('src', this.element.dataset.pickScheduleBoardUrl);
    $(this.$modalSchedule)
      .modal('show')
      .on('shown.bs.modal', () => {
        this.$modalSchedule.querySelector('#save-selected-schedule').addEventListener('click', () => this.saveSelectedSchedule());
      })
      .on('hidden.bs.modal', () => {
        turboFrame.innerHTML = '<div class="p-4">Carregando <span class="loading"></span></div>';
        document.querySelector('[data-controller="calendar-adjustment"]')['calendar-adjustment'].applyMask();
        document.querySelector('[data-controller="calendar-iteractive"]')['calendar-iteractive'].bindSelect2();
      });
  }

  saveSelectedSchedule() {
    let attributes = [...document.querySelectorAll('.schedule-board-modal .card.selected-schedule, .schedule-board-modal .card.selected-batch-schedule')].map(($el) => {
      return [...$el.querySelectorAll('.object-values')];
    }).flat(), object = {};

    attributes.map((node) => object[node.getAttribute('name').match(/\[(.*)?\]/gi)[0].replaceAll(/[\[\]]/gi, '')] = node.value)
    let [year, month, day] = object['date'].split('-');

    this.element.querySelector('.new-attendance-attributes').innerHTML = attributes.map((node) => node.outerHTML).join('');
    this.btnPickScheduleTarget.innerHTML = `
      <span class="mr-1">${new Date(+year, +month - 1, +day).toString().split(' ')[0]}</span>
      ${object['start_time']} às ${object['end_time']}
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
      </svg>
    `;
    $(this.$modalSchedule).modal('hide');
  }
}
